import React from 'react';
import { CssBaseline, makeStyles } from '@material-ui/core';
import { createTheme, ThemeProvider, createGenerateClassName, StylesProvider } from '@material-ui/core/styles';
import './styles-global.scss';
  
const useGlobalStyles = makeStyles(
    () => ({
        '@global': {
            '*:-webkit-full-screen': {
                height: '100%',
                width: '100%',
            },
            'html, body': {
                fontSize: '16px',
                boxSizing: 'border-box',
                backgroundColor: '#f4f4f4',
                // backgroundImage: 'linear-gradient(to bottom, #00508b 2.75rem, #f0f0f0 2.75rem)'
            },
            body: {
                padding: '10px 0 0 0',
            },
            '#root': {
                // height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                margin: '0 auto',
            },
        },
    }),
    { name: 'ViewportGlobals' }
);

const theme = createTheme({
    typography: {
        fontFamily: ["Microsoft JhengHei", "Arial", "Helvetica", "sans-serif"].join(','),
        fontSize: 12,
        button: {
            textTransform: 'none',
        },
        subtitle1: {
            fontWeight: 600,
            fontSize: '0.875rem',
            marginTop: '0.625rem',
        },
        body1: {
            fontWeight: 400,
            fontSize: '0.875rem',
        },
        h4: {
            fontWeight: 600,
            fontSize: '0.875rem',
            marginTop: '0.625rem',
        },
        h3: {
            fontWeight: 600,
            fontSize: '17.1pt',
            marginTop: '5px',
        },
        h6: {
            fontSize: '15pt',
            lineHeight: 1.2,
        },
    },
    palette: {
        primary: {
            main: '#00508b',
        },
        secondary: {
            main: '#f26f21',
        },
    },
    overrides: {
        MuiButton: {
            contained: {
                color: 'white',
                backgroundColor: '#a0a0a0',
            },
            containedPrimary: {
                color: 'white',
            },
            containedSecondary: {
                color: 'white',
            },
        },
    },
});

export default function Viewport(props) {
    useGlobalStyles();

    console.log(theme, 'theme');
    
    return (
        <StylesProvider generateClassName={createGenerateClassName({ productionPrefix: 'portal' })}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {props.children}
            </ThemeProvider>
        </StylesProvider>
    );
}
